/* KK16 AB test — Version 1 cart note (V3.2 redesign).
   The note's text lives in a small scrollable area with a floating
   "Scroll down for more" pill: tapping it scrolls the text down one step,
   and once the reader reaches the end the pill (and the bottom text fade)
   go away — they come back if the reader scrolls back up. Custom element so
   it keeps working when the cart drawer is re-rendered via section
   rendering. */
(function () {
    if (customElements.get('kk16-letter')) return;

    class Kk16Letter extends HTMLElement {
        connectedCallback() {
            // when the drawer re-renders via innerHTML, connectedCallback can
            // fire before the children are parsed — wait until they exist
            var self = this;
            this._tries = 0;
            (function tick() {
                if (!self.isConnected) return;
                if (!self.querySelector('.kk16-note__scroll')) {
                    if (self._tries++ < 60) self._raf = requestAnimationFrame(tick);
                    return;
                }
                self.setup();
            })();
        }

        setup() {
            this.scroller = this.querySelector('.kk16-note__scroll');
            this.pill = this.querySelector('.kk16-note__more');
            if (!this.scroller) return;

            var self = this;
            if (this.pill) {
                this.pill.addEventListener('click', function () {
                    self.scroller.scrollBy({
                        top: Math.max(80, self.scroller.clientHeight * 0.7),
                        behavior: 'smooth'
                    });
                });
            }
            this.scroller.addEventListener('scroll', function () { self.update(); }, { passive: true });
            this.update();
            // content/images may still be settling when the drawer re-renders
            this._settleTimer = setTimeout(function () { self.update(); }, 300);
        }

        disconnectedCallback() {
            if (this._settleTimer) clearTimeout(this._settleTimer);
            if (this._raf) cancelAnimationFrame(this._raf);
        }

        update() {
            var el = this.scroller;
            var scrollable = el.scrollHeight - el.clientHeight > 4;
            var atEnd = !scrollable || el.scrollTop + el.clientHeight >= el.scrollHeight - 12;
            el.classList.toggle('is-done', atEnd);
            if (this.pill) this.pill.classList.toggle('is-done', atEnd);
        }
    }

    customElements.define('kk16-letter', Kk16Letter);
})();
